module.exports = "/assets/site/images/mercarius.jpg?41fb3e9910c395f3a57d0a4c14a4b70a";